import type { QueryClient } from "@tanstack/react-query";

/**
 * Invalidate every cache key that depends on recipe data after a write.
 * Single source of truth so mutations don't drift apart and forget keys.
 *
 * Pass `recipeIds` to also invalidate the per-recipe detail cache(s).
 */
export function invalidateRecipeQueries(
    queryClient: QueryClient,
    recipeIds?: number | number[]
) {
    queryClient.invalidateQueries({ queryKey: ["manage-recipes"] });
    queryClient.invalidateQueries({ queryKey: ["recipes"] });
    queryClient.invalidateQueries({ queryKey: ["favoriteRecipes"] });
    queryClient.invalidateQueries({ queryKey: ["notYetTriedRecipes"] });
    queryClient.invalidateQueries({ queryKey: ["untriedRecipes"] });
    queryClient.invalidateQueries({ queryKey: ["recentlyAddedRecipes"] });
    queryClient.invalidateQueries({ queryKey: ["shelfSamples"] });
    queryClient.invalidateQueries({ queryKey: ["recipeTypeCounts"] });

    if (recipeIds === undefined) return;
    const ids = Array.isArray(recipeIds) ? recipeIds : [recipeIds];
    ids.forEach((id) => {
        queryClient.invalidateQueries({ queryKey: ["recipe", id] });
        queryClient.invalidateQueries({ queryKey: ["recipeLogs", id] });
    });
}
